import { CompanyContactExpansionPanelComponent } from './company-contact-expansion-panel/company-contact-expansion-panel.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModule } from '../ui.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CompanyFormComponent } from '@fullyops/features/companies/containers/company-form/company-form.component';
import { CompanyFormComponent as LegacyCompanyFormComponent } from './company-form/company-form.component';
import { ReportListComponent } from './report-list/report-list.component';
import { InterventionPartsComponent } from './ticket-support-request-parts/ticket-support-request-parts.component';
import { HistoryComponent } from '../../../shared/components/history/history.component';
import { UsersComponent } from './users/users.component';
import { UserFormComponent } from './user-form/user-form.component';
import { AnomalyFormComponent } from './anomaly-form/anomaly-form.component';
import { PartFormComponent } from './part-form/part-form.component';
import { UsersPartsComponent } from './users-parts/users-parts.component';
import { UserPartsFormComponent } from './user-parts-form/user-parts-form.component';
import { ContactsFiltersComponent } from './contacts-filter/contacts-filters.component';
import { CompaniesFiltersComponent } from './companies-filter/companies-filters.component';
import {
  BottomSheetMoreOptionsMobile,
  TicketSupportFormComponent,
} from './ticket-support-form/ticket-support-form.component';
import { AvatarModule } from 'ngx-avatars';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfigurationsFormComponent } from './configurations-form/configurations-form.component';
import { DropInputComponent } from './drop-input/drop-input.component';
import { DropReportInputComponent } from './drop-report-input/drop-report-input.component';
import { ListItemsV2Component } from './list-items-v2/list-items-v2.component';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PartsFiltersComponent } from './parts-filters/parts-filters.component';
import { SharedModule } from '@fullyops/shared/shared.module';
import { WorkOrderActionsComponent } from '@fullyops/legacy/ui/ui-crm/work-order-action/work-order-actions/work-order-actions.component';
import { WorkingHoursRegistryComponent } from '@fullyops/legacy/ui/ui-crm/working-hours-registry/working-hours-registry.component';
import { NewWorkingPeriodFormComponent } from '@fullyops/legacy/ui/ui-crm/working-period/new-working-period-form/new-working-period-form.component';
import { TravelsComponent } from '@fullyops/legacy/ui/ui-crm/travels/travels.component';
import { NewTravelFormComponent } from '@fullyops/legacy/ui/ui-crm/travels/new-travel-form/new-travel-form.component';
import { TicketSupportFormTrackingV2Component } from '@fullyops/legacy/ui/ui-crm/ticket-support-form-tracking-v2/ticket-support-form-tracking-v2.component';
import { WorkingPeriodComponent } from './working-period/working-period.component';
import { ToolbarComponent } from '../../../shared/components/toolbar/toolbar.component';
import { ActionButtonsComponent } from '../../../shared/components/action-buttons/action-buttons.component';
import { KebabMenuComponent } from '@fullyops/shared/components/kebab-menu/kebab-menu.component';
import { AnnotateWithCompletedFlagPipe } from '@fullyops/shared/pipes/annotate-with-completed-flag.pipe';
import { WorkOrderSchedulingIssuesComponent } from '@fullyops/features/work-orders/containers/scheduling-issues/scheduling-issues.component';
import { AutocompletingSelectMultipleComponent } from '@fullyops/shared/components/autocompleting-select-multiple/component';
import { AutocompletingSelectComponent } from '@fullyops/shared/components/autocompleting-select/component';
import { DateTimeRangeInputComponent } from '@fullyops/shared/components/date-time-range-input/date-time-range-input.component';
import { CompanyAssetsComponent } from '@fullyops/features/equipments/containers/company-assets/company-assets.component';
import { LocationListComponent } from '@fullyops/features/locations/containers/location-list/location-list.component';
import { ArrowComponent } from '@fullyops/shared/components/arrow/component';
import { FileUploadComponent } from '@fullyops/shared/components/file-upload/component';

const declarations = [
  AnomalyFormComponent,
  PartFormComponent,
  LegacyCompanyFormComponent,
  ConfigurationsFormComponent,
  CompanyContactExpansionPanelComponent,
  WorkOrderActionsComponent,
  ReportListComponent,
  InterventionPartsComponent,
  UsersComponent,
  UserFormComponent,
  UsersPartsComponent,
  UserPartsFormComponent,
  TicketSupportFormComponent,
  BottomSheetMoreOptionsMobile,
  ContactsFiltersComponent,
  CompaniesFiltersComponent,
  WorkingPeriodComponent,
  DropInputComponent,
  DropReportInputComponent,
  ListItemsV2Component,
  PartsFiltersComponent,
  WorkingHoursRegistryComponent,
  NewWorkingPeriodFormComponent,
  TravelsComponent,
  NewTravelFormComponent,
  TicketSupportFormTrackingV2Component,
];

@NgModule({
  declarations,
  exports: [...declarations, HistoryComponent],
  imports: [
    CommonModule,
    UiModule,
    FormsModule,
    ReactiveFormsModule,
    AvatarModule,
    FontAwesomeModule,
    RouterModule,
    InfiniteScrollModule,
    SharedModule,
    ToolbarComponent,
    ActionButtonsComponent,
    KebabMenuComponent,
    AnnotateWithCompletedFlagPipe,
    WorkOrderSchedulingIssuesComponent,
    AutocompletingSelectMultipleComponent,
    AutocompletingSelectComponent,
    ArrowComponent,
    DateTimeRangeInputComponent,
    HistoryComponent,
    CompanyFormComponent,
    CompanyAssetsComponent,
    LocationListComponent,
    FileUploadComponent,
  ],
})
export class UiCrmModule {}
